import api from "@/api/axios.js";

// Una risposta senza utente (es. una pagina HTML con esito positivo) non e' una sessione:
// va trattata come server non disponibile, mai come utente collegato. Vale per login e /me.
function requireUser(r)
{
	const user = r.data?.user;
	if (!user?.username)
	{
		const e = new Error("invalid_user_response");
		e.code = "INVALID_USER_RESPONSE";
		throw e;
	}
	return user;
}

export const login = (username, password, remember = true) =>
	api.post("/api/auth/login", {username, password, remember}).then(requireUser);

export const logout = () =>
	api.post("/api/auth/logout").then(r => r.data);

export const me = () =>
	api.get("/api/auth/me").then(requireUser);

export const refresh = () =>
	api.post("/api/auth/refresh").then(r => r.data.user);

export const changePassword = (currentPassword, newPassword) =>
	api.patch("/api/auth/password", {currentPassword, newPassword}).then(r => r.data);

export const getMenuCatalog = () =>
	api.get("/api/auth/menu-catalog").then(r => r.data);
